import React, { useEffect, useState } from 'react';
import moment from 'moment';
import axios from '../../../helpers/axios';
import {
  Table,
  Spin,
  Button,
  message,
  Col,
  Row,
  Divider,
  Upload,
  Tooltip,
  Input,
  Tabs,
  Form,
  Card,
  Descriptions,
} from 'antd';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { GlobalUtilityStyle } from '../../styled';
import { useUser } from '../../../context/UserContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { QuestionCircleTwoTone, UploadOutlined } from '@ant-design/icons';
import UilArrowLeft from '@iconscout/react-unicons/icons/uil-arrow-left';

const { TabPane } = Tabs;

function QAUpload() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useUser();
  const [formHandler] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [form, setForm] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [companyDetails, setCompanyDetails] = useState(null);

  const userRole = localStorage.getItem('userRole');

  const handleUploadFiles = ({ fileList }) => {
    if (fileList.length > 1) {
      message.warning('You can only upload one file.');
      fileList = [fileList[fileList.length - 1]];
    }

    setFileList(fileList);

    message.success('File uploaded successfully');
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/api/file/qa/encoded/?data_repo_id=${location.state.id}`);
        setForm(response.data.data);
        setCompanyDetails(response.data.data ? response.data.data.company_details : null);
      } catch (error) {
        console.error('Error fetching data:', error);
        message.error('Failed to load data');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [location.state.id]);

  const renderCompanyRelatedForm = (form) => (
    <div className="p-[25px] bg-white dark:bg-white10 m-0 mb-[25px] rounded-10 relative">
      <Row gutter={26} className="mt-4">
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Form Type Category</label>
            <Input value={form.category} disabled />
          </div>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Form Type</label>
            <Input value={form.data_resource} disabled />
          </div>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Submission Type</label>
            <Input value={form.document_type} disabled />
          </div>
        </Col>
      </Row>
      <Divider className="mb-8 mt-10" />
      <Row gutter={26} className="mt-4">
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Date Received</label>
            <Input value={form.date_receipt} disabled />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Date Approved</label>
            <Input value={form.date_created} disabled />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Period Covered</label>
            <Input value={form.period_covered} disabled />
          </div>
        </Col>
      </Row>
    </div>
  );

  const renderNonCompanyRelatedForm = (form) => (
    <div className="p-[25px] bg-white dark:bg-white10 m-0 mb-[25px] rounded-10 relative">
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={16}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Tax Form-related</label>
            <Input value={form.company_related ? 'TRUE' : 'FALSE'} disabled />
          </div>
        </Col>
      </Row>
      <Divider />
      <Row gutter={[16, 16]} className="mt-4">
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Receiving Branch</label>
            <Input value={form.receiving_branch} disabled />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Received From</label>
            <Input value={form.received_from} disabled />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Received On</label>
            <Input value={moment(form.date_receipt).format('YYYY-MM-DD')} disabled />
          </div>
        </Col>
      </Row>
      <Divider />
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Sender Name</label>
            <Input value={form.source} disabled />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Sender Contact Information</label>
            <Input value={form.source_contact_info} disabled />
          </div>
        </Col>
      </Row>
      <Divider />
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Addressee Department</label>
            <Input value={form.office_type} disabled />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Addressee Name</label>
            <Input value={form.addressee_name} disabled />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Addressee(s)</label>
            <Input value={form.addressee} disabled />
          </div>
        </Col>
      </Row>
      <Divider />
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Subject</label>
            <Input value={form.subject} disabled />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Form Type</label>
            <Input value={form.data_resource} disabled />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Confidential</label>
            <Input value={form.is_confidential ? 'TRUE' : 'FALSE'} disabled />
          </div>
        </Col>
      </Row>
      <Divider />
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={16}>
          <div className="flex flex-col gap-2">
            <label className="font-medium">Remarks</label>
            <Input.TextArea value={form.remarks} disabled />
          </div>
        </Col>
      </Row>
    </div>
  );

  const handleSubmit = async (values) => {
    if (fileList.length === 0) {
      message.error('Please upload at least one file');
      return;
    }

    setSubmitLoader(true);
    const formData = new FormData();
    formData.append('doc_id', location.state.doc_id);

    fileList.forEach((file) => {
      formData.append('files', file.originFileObj);
    });

    try {
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      const response = await axios.post('/api/file/upload/v2/', formData, config);
      message.success('File uploaded and form submitted successfully');
      setSubmitLoader(false);
      setTimeout(() => {
        navigate(`/${userRole}/pages/index-form`);
      }, 2000);
    } catch (error) {
      setSubmitLoader(false);
      message.error('File upload failed');
      console.error(error);
    }
  };

  return (
    <>
      <PageHeader
        title={`QA Form Upload - ${location.state.doc_id}`}
        className="mt-5 px-8 xl:px-[15px] pt-2 pb-2 sm:pb-[30px] bg-transparent"
      />
      <Divider />
      <Form name="hexadash-vertical-form" layout="vertical" form={formHandler} onFinish={handleSubmit}>
        <div className="p-[25px] mx-8 bg-white dark:bg-white10 m-0 mb-[25px] rounded-10 relative">
          <div className="flex items-center justify-between flex-wrap">
            <div className="flex items-center">
              <Upload
                multiple={false}
                beforeUpload={() => false}
                fileList={fileList}
                onChange={handleUploadFiles}
                showUploadList
              >
                <Button icon={<UploadOutlined />}>Upload File</Button>
              </Upload>
              <Tooltip title="Hover on the uploaded file to remove." className="ml-2">
                <QuestionCircleTwoTone twoToneColor="#0ee395" />
              </Tooltip>
            </div>

            <Link
              to={`/${userRole}/pages/index-form`}
              className="bg-primary border-solid border-1 border-primary text-white dark:text-white87 text-[14px] font-semibold leading-[22px] inline-flex items-center justify-center rounded-[4px] px-[20px] h-[30px]"
              type="primary"
              ghost
            >
              <UilArrowLeft className="w-4 dark:text-white60 mr-1" />
              Back to List
            </Link>
          </div>
        </div>

        {form
          ? form.company_related === true && (
              <div className="flex-1 h-auto px-8 xl:px-[15px] pb-[20px] bg-transparent mb-10">
                <Card title="Profile Information">
                  <Descriptions column={2} bordered>
                    <Descriptions.Item label="Identification Number">
                      {companyDetails?.sec_no || 'Not Available'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Name">
                      {companyDetails?.company_name || 'Not Available'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Type">
                      {companyDetails?.type || 'Not Available'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Date of Registration">
                      {companyDetails?.date_of_incorporation
                        ? moment(companyDetails.date_of_incorporation).format('MMM DD, YYYY')
                        : 'Not Available'}
                    </Descriptions.Item>
                    <Descriptions.Item label="PSIC Code">
                      {companyDetails?.psic_code || 'Not Available'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Industry">
                      {companyDetails?.industry || 'Not Available'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Status">{companyDetails?.status || 'Not Available'}</Descriptions.Item>
                    <Descriptions.Item label="Address">{companyDetails?.address || 'Not Available'}</Descriptions.Item>
                  </Descriptions>
                </Card>
              </div>
            )
          : null}
        <div className="flex-1 h-auto px-8 xl:px-[15px] pb-[20px] bg-transparent">
          <GlobalUtilityStyle>
            {loading ? (
              <Spin size="large" className="flex justify-center items-center h-full" />
            ) : form && form.company_related === true ? (
              renderCompanyRelatedForm(form)
            ) : (
              renderNonCompanyRelatedForm(form)
            )}
            {!loading && (
              <div className="flex flex-col justify-end items-end">
                <Button htmlType="submit" className="bg-primary text-white" loading={submitLoader}>
                  Submit
                </Button>
              </div>
            )}
          </GlobalUtilityStyle>
        </div>
      </Form>
    </>
  );
}

export default QAUpload;
